import { Routes } from '@angular/router';
import {AuthenticationComponent} from "./core/components/authentication/authentication.component";

export const routes: Routes = [
  {
    path: '',
    component: AuthenticationComponent,
  },
  {
    path: 'authentication',
    component: AuthenticationComponent,
  },
  {
    path: 'dashboard',
    title: 'Dashboard · Boardroom',
    loadComponent: () =>
      import('./boardroom/components/dashboard/dashboard.component').then((m) => m.DashboardComponent),
  },
  {
    path: 'book',
    title: 'Book · Boardroom',
    loadComponent: () =>
      import('./boardroom/components/booking/booking.component').then((m) => m.BookingComponent),
  },
  {
    path: 'rooms',
    title: 'Rooms · Boardroom',
    loadComponent: () =>
      import('./boardroom/components/rooms/rooms.component').then((m) => m.RoomsComponent),
  },
  // { path: '**', redirectTo: 'dashboard' },
];
